export default __webpack_public_path__ + "static/media/ketochickennuggets@3x.aea97827.jpg";